import React, { useEffect, useState } from 'react';

const AVATAR_COLORS = [
  ['#1F5A45', '#E7F0EA'],
  ['#B6791A', '#F7EBD3'],
  ['#3F6FB0', '#E6EDF6'],
  ['#B5546B', '#F6E6EA'],
  ['#5B6B4A', '#ECEFE2'],
  ['#7A5BA6', '#EEE8F5'],
];

function hashStr(value = '') {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function InitialsAvatar({ name, size, fg, bg, initials }) {
  return (
    <div
      className="platform-avatar"
      style={{
        width: size,
        height: size,
        background: bg,
        color: fg,
        fontSize: size * 0.36,
      }}
      aria-hidden="true"
    >
      {initials || '?'}
    </div>
  );
}

function PlatformAvatar({ name = '', size = 40, photoUrl }) {
  const [imageFailed, setImageFailed] = useState(false);
  const [fg, bg] = AVATAR_COLORS[hashStr(name) % AVATAR_COLORS.length];
  const initials = name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  useEffect(() => {
    setImageFailed(false);
  }, [photoUrl]);

  if (photoUrl && !imageFailed) {
    return (
      <img
        src={photoUrl}
        alt=""
        className="platform-avatar"
        style={{
          width: size,
          height: size,
          objectFit: 'cover',
        }}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return <InitialsAvatar name={name} size={size} fg={fg} bg={bg} initials={initials} />;
}

export default PlatformAvatar;
